import { NgModule } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { StoreModule } from "@ngrx/store";
import { modalReducer } from "./store/modal.reducer";
import { ModalErrorComponent } from "./error/error.component";
import { ModalComponent } from "./modal.component";
import { EffectsModule } from "@ngrx/effects";
import { ModalEffects } from "./store/modal.effect";
import { ConfirmCloseOverlayComponent } from "./confirm-close-overlay/confirm-close-overlay.component";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { ConnectionInterruptedOverlayComponent } from "./connection-interrupted-overlay/connection-interrupted-overlay.component";
import { ConnectionStoppedOverlayComponent } from "./connection-stopped-overlay/connection-stopped-overlay.component";
import { SurveyOverlayComponent } from "./survey-overlay/survey-overlay.component";
import { StartSurveyOverlayComponent } from "./survey-overlay/start-survey-overlay/start-survey-overlay.component";
import { FixedBlackBackgroundComponent } from "./fixed-black-background/fixed-black-background.component";
import { PopupContainerComponent } from "./popup-container/popup-container.component";
import { UtilsModule } from "../utils/utils.module";
import { NgxPermissionsModule } from "ngx-permissions";
import { BrandingModule } from "../branding/branding.module";
import { ConfirmModalComponent } from "./confirm-modal/confirm-modal.component";
import { MatDialogModule } from "@angular/material/dialog";

@NgModule({
    imports: [
        StoreModule.forFeature("modal", modalReducer),
        EffectsModule.forFeature([ModalEffects]),
        TranslateModule.forChild(),
        CommonModule,
        UtilsModule,
        NgxPermissionsModule,
        BrandingModule,
        MatDialogModule,
        ModalComponent,
        ModalErrorComponent,
        ConfirmCloseOverlayComponent,
        ConnectionInterruptedOverlayComponent,
        ConnectionStoppedOverlayComponent,
        SurveyOverlayComponent,
        FixedBlackBackgroundComponent,
        PopupContainerComponent,
        StartSurveyOverlayComponent,
        ConfirmModalComponent,
    ],
    providers: [NgbActiveModal],
    exports: [
        ModalComponent,
        FixedBlackBackgroundComponent,
        PopupContainerComponent,
        SurveyOverlayComponent,
    ],
})
export class ModalModule {}
